import { createContext, useCallback, useContext, useState } from "react";

const CastingContext = createContext(null);

export const CastingProvider = ({ children }) => {
  const [board, setBoard] = useState([]);

  const toggle = useCallback((model) => {
    setBoard((prev) =>
      prev.some((m) => m.id === model.id)
        ? prev.filter((m) => m.id !== model.id)
        : [...prev, model]
    );
  }, []);

  const remove = useCallback((id) => {
    setBoard((prev) => prev.filter((m) => m.id !== id));
  }, []);

  const clear = useCallback(() => setBoard([]), []);

  const has = useCallback((id) => board.some((m) => m.id === id), [board]);

  return (
    <CastingContext.Provider value={{ board, toggle, remove, clear, has }}>
      {children}
    </CastingContext.Provider>
  );
};

export const useCasting = () => useContext(CastingContext);
